module.exports = __webpack_public_path__ + "static/media/logo.e7916c9d.png";